import { AppProps } from './types';

export function getTrackingContextFrom(props: Partial<AppProps>) {
    return {
        userId: props.user?.id || 0,
        locale: props.env?.localeInfo.locale || '',
        event: {
            id: props.event?.id || '',
            isOnline: props.event?.isOnlineEvent || false,
        },
        featureFlags: {
            enable_fe_tracking_on_related_events:
                props.settings?.featureFlags
                    ?.enable_fe_tracking_on_related_events || false,
            enable_fe_placement_on_related_events:
                props.settings?.featureFlags
                    ?.enable_fe_placement_on_related_events || false,
        },
    };
}
